import { Routes } from "@angular/router";

import { checkIfLoggedInFn, numericIdGuard, PingGuard, RedirectedUrlGuard } from "../../core/guards";
import { adaa4UserGuard } from "./adaa4-guard";
import { Adaa4HomeComponent } from "./adaa4-home/adaa4-home";
import { Adaa4LayoutComponent } from "./adaa4-layout/adaa4-layout";
import { Adaa4NotificationActionComponent } from "./adaa4-notifications/adaa4-notification-action/adaa4-notification-action";
import { Adaa4NotificationDetailsComponent } from "./adaa4-notifications/adaa4-notification-details/adaa4-notification-details";
import { Adaa4NotificationsListComponent } from "./adaa4-notifications/adaa4-notifications-list/adaa4-notifications-list";

export const ADAA4_ROUTES: Routes = [
  {
    path: "homepage",
    component: Adaa4LayoutComponent,
    canActivate: [RedirectedUrlGuard(), checkIfLoggedInFn, adaa4UserGuard],
    canActivateChild: [PingGuard()],
    children: [
      {
        path: "",
        component: Adaa4HomeComponent,
        data: { title: "navigation.home" },
      },
      {
        path: "notifications",
        data: { title: "breadcrumbs.communications" },
        children: [
          { path: "", component: Adaa4NotificationsListComponent },
          {
            path: ":id",
            component: Adaa4NotificationDetailsComponent,
            canActivate: [numericIdGuard("/homepage/notifications")],
          },
          {
            path: ":id/action",
            component: Adaa4NotificationActionComponent,
            canActivate: [numericIdGuard("/homepage/notifications")],
          },
        ],
      },
    ],
  },
];
